"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBarTextLogo = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../helpers");
exports.AppBarTextLogo = styled_components_1.default.span `
    color: ${(props) => props.theme.colorTextHeader};
    font-family: ${helpers_1.BASE_FONT_FAMILY};
    font-size: ${helpers_1.FONT_SIZE_XL};
    font-weight: ${helpers_1.BASE_FONT_NORMAL_WEIGHT};
    user-select: none;
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
//# sourceMappingURL=AppBarTextLogo.js.map